import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/v1`,
  withCredentials: true,
});

const QUIET_401 = ["/auth/login", "/auth/me", "/invitations/"];
const BILLING_LOCK_MESSAGE = "Sekolah Anda memiliki tagihan belum bayar";

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !QUIET_401.some((p) => url.includes(p))) {
      window.dispatchEvent(new Event("sist:session-expired"));
    }
    // Redirect ke Langganan jika akun dikunci karena tagihan belum bayar
    if (err.response?.status === 403) {
      const msg = err.response.data?.detail || "";
      if (typeof msg === "string" && msg.includes(BILLING_LOCK_MESSAGE)) {
        // Jangan redirect jika sudah di halaman Langganan
        if (!window.location.pathname.includes("/sekolah/langganan")) {
          window.location.href = "/sekolah/langganan";
          return Promise.reject(err);
        }
      }
    }
    return Promise.reject(err);
  },
);

export function errorMessage(err) {
  if (!err?.response) return "Tidak dapat terhubung ke server. Periksa koneksi Anda.";
  const d = err.response.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return "Terjadi kesalahan. Silakan coba lagi.";
}

export const fetcher = (url) => api.get(url).then((r) => r.data);
